// extracted by mini-css-extract-plugin
export var pageBody = "page-module--page-body--1rV_R";
export var pageBodyInner = "page-module--page-body-inner--1-huW";
export var pageContent = "page-module--page-content--yM0FU";
export var pageContentDocument = "page-module--page-content--document--OtsaF";
export var pageFooter = "page-module--page-footer--kFCnk";
export var pageSidebar = "page-module--page-sidebar--3-yiv";